(ns app.front.view.party.invite-v2
  (:require [app.domain.party.model :as party-model]
            [app.domain.requirement.model :as req-model]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.radio :as ui-radio]
            [app.front.util :as futil]
            [app.front.view.party.business :as party-business]
            [app.front.view.party.common :as common]
            [app.front.view.party.edit :as edit]
            [app.front.view.party.registered-contractor :as party-registered-contractor]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.schemas :as schemas]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(rf/reg-event-fx ::find-party-by-email
  (fn [_ [_ email]]
    (when (nil? (s/check schemas/Email email))
      {:comm/command {:command    :party/find-by-email
                      :method     :get
                      :data       {:email email}
                      :on-success [::find-party-by-email.success]}})))


(rf/reg-event-fx ::find-party-by-email.success
  (fn [{:keys [db]} [_ _ data]]
    (when (:user/first-name data)
      {:db (update db ::common/document merge data)})))


(rf/reg-event-fx ::email-changed
  (fn [{:keys [db]} [_ email]]
    ; Update fields only if they are empty and manual mode has been selected
    (when (and (-> db ::common/document ::common/manual-mode?)
               (->> [:user/first-name
                     :user/last-name
                     :user/street-address]
                    (every? #(-> db ::common/document % str/blank?))))
      {:dispatch [::find-party-by-email email]})))


(rf/reg-event-fx ::edit-other-party
  (fn [{:keys [db]} [_ party]]
    {:db         (common/reset-db db)
     :dispatch-n [[::edit/init (party-model/merge-user-and-party party)]
                  [::edit/toggle-edit-party-modal (:db/id party)]]}))

(defn message-text [tr]
  (ui/text-area {:id         "invite-message"
                 :label-text (tr [:party/personal-message])
                 :on-change  #(rf/dispatch-sync [::common/set-doc-value [:invite/message] (futil/tval %)])
                 :value      (or (<sub [::common/document [:invite/message]]) "")}))


(defn person-form [tr target existing-parties]
  (let [target-id      (:db/id target)
        do-submit      #(>evt [::common/submit-clicked tr target-id])
        document       (<sub [::common/document])
        email-value    (:party/email document)
        manual-mode?   (::common/manual-mode? document)
        existing-party (->> existing-parties
                            (filter #(= email-value (:party/email %)))
                            first)
        validator      (<sub [::common/validator])
        party-roles    (<sub [::common/document-party-roles])
        modify-roles   (common/roles-requiring-modify-application (<sub [::ws-subs/required-so-roles]))
        on-role-toggle (if (common/has-extra-permission target :party/modify-application)
                         (common/role-toggle-change-permissions-fn
                           modify-roles
                           (map :party-role/key party-roles)
                           :party/modify-application)
                         (constantly nil))
        workspace      (:entity/parent target)
        permissions    (and (not (str/blank? email-value))
                            (common/available-extra-permissions workspace target))]
    [:div.mt-4
     [:p.p-0
      (tr [:party/add-help])]
     [:form.flex.flex-col.w-full.mt-6
      {:on-submit (fn [ev]
                    (.preventDefault ev)
                    (do-submit))}
      [:fieldset
       [:div.flex.mb-6
        [:div
         {:class (when permissions "flex-1")
          :style {:min-height "115px"}}
         [common/email-input {:class-name     "invite-email"
                              :tr             tr
                              :validator      validator
                              :field          :party/email
                              :label          :user/email
                              :on-save-needed (fn [_ v]
                                                (rf/dispatch-sync [::email-changed v]))}]
         [:div.mt-4
          (if existing-party
            [:div.font-bold.text-danger
             [:span.mr-1 (tr [:party/existing-email-warning])]
             (if (party-model/active? existing-party)
               (cc/link {:href     ""
                         :on-click #(>evt [::edit-other-party existing-party])}
                        (tr [:party/edit-existing]))
               (tr [:party/delete-existing]))]
            (cc/checkbox {:id         "add-party-manually-checkbox"
                          :label-text (tr [:party/input-manually])
                          :checked    (boolean manual-mode?)
                          :on-change  (fn [value]
                                        (>evt [::common/set-doc-value [::common/manual-mode?] value])
                                        (if value
                                          (>evt [::find-party-by-email email-value])
                                          (>evt [::common/reset-manual-party-fields])))}))]]
        (when permissions
          [:div.flex-1.ml-4
           [common/additional-permissions (util/mmap permissions tr target)]])]

       (when manual-mode?
         [common/common-editor-fields-v2 {:tr          tr
                                          :target-id   target-id
                                          :validator   validator
                                          :show-email? false}])

       [:div.flex-row
        [:div.mb-6
         [common/role-selector (util/mmap {:on-toggle on-role-toggle} tr validator target-id)]]
        (when-not (str/blank? email-value)
          [:div.mb-6
           [message-text tr]])]]]]))

(rf/reg-event-fx ::set-party-type
  (fn [{:keys [db]} [_ party-type new-roles]]
    {:fx [[:dispatch [::common/set-doc-value [:party/type] party-type]]
          (when (= party-type :party.type/registered-contractor)
            [:dispatch [::party-registered-contractor/init]])]
     :db (assoc-in db [::common/document :party/party-roles] (set new-roles))}))

(defn invite-modal [tr target existing-parties]
  (let [target-id                (:db/id target)
        open?                    (or (<sub [::common/invite-open]) false)
        document                 (<sub [::common/document])
        email-value              (:party/email document)
        manual-mode?             (::common/manual-mode? document)
        existing-party           (->> existing-parties
                                      (filter #(= email-value (:party/email %)))
                                      first)
        party-type               (<sub [::common/party-type])
        display-business-option? (<sub [::process/signal-permitted? target [:process.signal/add-new-business]])
        ;; allow adding from contractor registry only if some required role has a trade requirement
        display-cr-option?       (->> (req-model/phase-role-requirements target)
                                      (keep :requirement/party-role)
                                      (keep :party-role/trade)
                                      seq)
        party-type-values        (remove nil?
                                         [:party.type/person
                                          (when display-business-option? :party.type/business)
                                          (when display-cr-option? :party.type/registered-contractor)])
        current-party-roles      (<sub [::common/document-party-roles])
        process                  (<sub [::process/entity-process target-id])]
    [:div {:data-cy "add-party-modal"}
     (when open?
       [ui-modal/composed-input-modal
        {:open       open?
         :on-close   #(>evt [::common/close])
         :aria-label (tr [:party/add])}
        (cc/modal-header {:close-modal #(>evt [::common/close])
                          :title       (tr [:party/add])})
        (cc/modal-body
          {}
          [:div.flex.flex-col.pb-1
           (when (> (count party-type-values) 1)
             [:div.flex-row.border-b.border-solid.pb-6.mt-4
              [ui-radio/radio {:name      "new-party-type"
                               :values    party-type-values
                               :value     party-type
                               :val->str  #(str (tr [:add]) " " (tr [%]))
                               :on-change (fn [party-type]
                                            (>evt [::set-party-type
                                                   party-type
                                                   (common/permitted-party-role-ids current-party-roles
                                                                                    process
                                                                                    :invite
                                                                                    party-type)]))}]])
           (case party-type
             :party.type/business              [:div.mt-4 [party-business/business-form tr target]]
             :party.type/registered-contractor [party-registered-contractor/contractor-search tr target]
             [person-form tr target existing-parties])
           [:div
            (case party-type
              :party.type/business              [party-business/add-select-buttons-content (util/mmap tr target)]
              :party.type/registered-contractor [party-registered-contractor/add-contractor-buttons (util/mmap tr target)]
              [common/invite-buttons-content (util/mmap {:kind      (if manual-mode?
                                                                      :party/add-button
                                                                      :party/send-button)
                                                         :disabled? (boolean existing-party)}
                                                        tr
                                                        target-id)])]])])]))
